(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-product-preview"]) return;
  try {
    
document.querySelectorAll('.dw-pdp-thumbs button').forEach(button=>{button.addEventListener('click',()=>{const rail=button.closest('.dw-pdp-gallery').querySelector('.dw-pdp-slides');rail.scrollTo({left:rail.clientWidth*Number(button.dataset.photo),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});});

  } catch(e) { console.error(e); }
})();
})();
